import React from 'react'
import { SegmentedControl } from '@s4l/ds'
import { IconSlidersHorizontal } from '@s4l/icons/IconSlidersHorizontal'
import { IconLayoutList } from '@s4l/icons/IconLayoutList'
import { useS4LContext } from '@s4l/react-context'
import type { UtilityClassNames } from '@s4l/utility-css'

export type RoomView = 'configurator' | 'list'

interface RoomViewSelectorProps {
  value: RoomView
  onValueChange: (value: RoomView) => void
  className?: UtilityClassNames
}

const ICON_SIZE = 18

const RoomViewSelector = ({ value, onValueChange, className }: RoomViewSelectorProps) => {
  const { i18n } = useS4LContext()

  const configuratorLabel = i18n.formatMessage({ id: 'room-view-selector.configurator' })
  const listLabel = i18n.formatMessage({ id: 'room-view-selector.list' })

  const items = [
    {
      value: 'configurator' as const,
      title: configuratorLabel,
      label: <IconSlidersHorizontal width={ICON_SIZE} height={ICON_SIZE} aria-hidden />,
    },
    {
      value: 'list' as const,
      title: listLabel,
      label: <IconLayoutList width={ICON_SIZE} height={ICON_SIZE} aria-hidden />,
    },
  ]

  return (
    <SegmentedControl
      items={items}
      value={value}
      onValueChange={onValueChange as (value: string) => void}
      className={className}
      dataTestId="room-view-selector"
    />
  )
}

RoomViewSelector.displayName = 'RoomViewSelector'
export default RoomViewSelector
